// extracted by mini-css-extract-plugin
export var body = "_lk-0";
export var sectionHeader = "_lk-4";
export var shortcutColumns = "_lk-2";
export var shortcutList = "_lk-1";
export var shortcutSection = "_lk-3";